import { useCallback, useState, useEffect } from "react";
import Main from "../../components/layouts/Main";
import PageTitle from "../../components/utils/PageTitle";
import { useUserContext } from "../../contexts/UserContext";
import Breadcrumb from "../../components/utils/Breadcrumb";
import { catchError } from "../../services/DaoService";
import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import {
  PlusCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { PrioriteService } from "../../services/PrioriteService";
import PrioriteCreateForm from "../../components/priorite/PrioriteCreateForm";
import PrioriteList from "../../components/priorite/PrioriteList";
// import PropTypes from "prop-types";


export default function PrioriteListPage() {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const { check } = useUserContext();
  const [searchText, setSearchText] = useState(null);
  const [statut, setStatut] = useState('tout');
  const [priorites, setPriorites] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    PrioriteService.getInstance()
      .search({ searchText, statut })
      .then((response) => {
        setPaginationData(response.data);
        setPriorites(response.data.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchText, statut]);

  useEffect(() => {
    init();
  }, [init, check]);

  const handleCreation = () => {
    init();
  };

  const labelStyle = {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };

  return (
    <Main>
      <Breadcrumb
        parentLink="/settings"
        canSee={check("VIEW-SETTINGS")}
        parentLinkTitle="Paramétrage"
        title="Priorités"
      />
      <PageTitle
        title="Liste des priorités"
        subTitle="Gestion des priorités"
        icon={<PlusCircleFilled />}
      >
        <Button
          type="primary"
          icon={<PlusCircleFilled />}
          onClick={() => setNewModalVisible(true)}
        >
          Ajouter une priorité
        </Button>
        <Button type="default" icon={<ReloadOutlined />} onClick={init}>
          Rafraîchir
        </Button>
      </PageTitle>
      <Card>
        <Row gutter={[16, 16]} justify={"center"}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Input.Search
              size="large"
              value={searchText}
              onInput={(e) => setSearchText(e.target.value)}
              placeholder="Rechercher par nom ou code"
            />
          </Col>
          <Col xs={24} md={8} lg={6}>
            <div style={containerStyle}>
              <div style={labelStyle}>Statut:</div>
              <Select size="large"
                value={statut}
                onChange={(value) => {
                  setStatut(value);
                }}
                placeholder="Filtrer par statut"
                style={{ width: "100%" }}
              >
                <Select.Option value="tout">Tous</Select.Option>
                <Select.Option value="actif">Activé</Select.Option>
                <Select.Option value="inactif">Désactivé</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <PrioriteList priorites={priorites} setPriorites={setPriorites} paginationData={paginationData} setPaginationData={setPaginationData} searchText={searchText} />
        </Spin>
      </Card>

      <PrioriteCreateForm
        visible={newModalVisible}
        onCreate={handleCreation}
        onCancel={() => setNewModalVisible(false)}
      />
    </Main>
  );
}


PrioriteListPage.propTypes = {
  // renseigner les props du composant ici
};
